import { render } from "./systemRestore.vue?vue&type=template&id=02728350&scoped=true"
import script from "./systemRestore.vue?vue&type=script&lang=js"
export * from "./systemRestore.vue?vue&type=script&lang=js"

import "./systemRestore.vue?vue&type=style&index=0&id=02728350&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02728350"]])

export default __exports__